module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-header-2-e4480d9c0c97e53f8d9fe7e1250e2b6a.jpg";